import React, { useEffect } from 'react'

import { Card, ErrorBoundary } from 'components'
import { useGet, useLoading, usePersistForm } from 'hooks'
import moment from 'moment'
import { FormProvider, useForm } from 'react-hook-form'
import { IPaginatedEntityGST } from 'services/core/genericEntityGST'
import { DateTime } from 'services/database/reportsDatabase'
import {
  Iitems,
  IPesquisaContratosGetByFilterParams
} from 'services/GST/PesquisaPorContrato'
import { FORMAT, FUNCTIONS, SPACING } from 'utils'

import { IForm } from '../../types'
import { FilterTable } from './components/filterTable'
import { TableContracts } from './components/tableContracts'

const DEFAULT_FORM_VALUE: IForm = {
  cdContrato: '',
  centroPlantaId: undefined,
  documentoStatus: undefined,
  dtCadastroFinal: null,
  dtCadastroInicial: null,
  empresaId: undefined,
  enviarListas: true,
  itemSegurancaId: undefined,
  nmContraparte: '',
  nmFornecedor: ''
}

const Search: React.FC = () => {
  const { setLoading } = useLoading()
  const methods = useForm<IForm>({
    defaultValues: DEFAULT_FORM_VALUE
  })

  usePersistForm('search-for-contract-form', {
    setValue: methods.setValue,
    watch: methods.watch
  })

  const returnPersistObjFormated = () => {
    return {
      ...methods.getValues(),
      dtCadastroFinal: methods.getValues('dtCadastroFinal')
        ? moment(methods.getValues('dtCadastroFinal')).toISOString()
        : '',
      dtCadastroInicial: methods.getValues('dtCadastroInicial')
        ? moment(methods.getValues('dtCadastroInicial')).toISOString()
        : ''
    }
  }

  const {
    data: tableData,
    refresh: refreshTable,
    isFirstGet: isFirstGet,
    handleChangePage,
    handleChangeRowsPerPage,
    page,
    rowsPerPage
  } = useGet<
    IPesquisaContratosGetByFilterParams,
    IPaginatedEntityGST<Iitems[]>
  >({
    api: 'Gst',
    isPaginated: true,
    params: {
      ...FUNCTIONS.filterObject(
        {
          ...methods.getValues(),
          dtCadastroFinal: methods.getValues('dtCadastroFinal')
            ? moment(methods.getValues('dtCadastroFinal')).toISOString()
            : '',
          dtCadastroInicial: methods.getValues('dtCadastroInicial')
            ? moment(methods.getValues('dtCadastroInicial')).toISOString()
            : ''
        },
        Boolean
      )
    },
    url: 'ItemSegurancaContrato/GetContratosByFilter',
    formPersist: {
      getValues: () => returnPersistObjFormated()
    }
  })

  const dataInicial: DateTime = methods.watch('dtCadastroInicial')
  const dataFinal: DateTime = methods.watch('dtCadastroFinal')

  const areDatesValid = () => {
    return (
      moment(dataInicial || moment()).isValid() &&
      moment(dataFinal || moment()).isValid()
    )
  }

  const handleSubmitForm = (form: IForm) => {
    const formFormatado: IForm = {
      ...form,
      cdDocto: form.cdDocto && FORMAT.unMask(form.cdDocto),
      dtCadastroFinal: form.dtCadastroFinal
        ? moment(form.dtCadastroFinal).format('YYYY-MM-DD')
        : '',
      dtCadastroInicial: form.dtCadastroInicial
        ? moment(form.dtCadastroInicial).format('YYYY-MM-DD')
        : ''
    }

    refreshTable({
      ...FUNCTIONS.filterObject(formFormatado, Boolean)
    })
  }

  useEffect(() => {
    setLoading('loading')

    if (tableData != undefined) {
      setLoading('idle')
    }
  }, [tableData])

  return (
    <FormProvider {...methods}>
      <Card
        marginLeft={SPACING.spacing20}
        marginRight={SPACING.spacing20}
        marginBottom={SPACING.spacing100}
        padding={SPACING.spacing20}
        boxShadow={`0px -1px 32px rgba(50, 50, 71, 0.12), 0px 24px 32px rgba(50, 50, 71, 0.12)`}
        borderRadius={`0px 10px 0px 0px`}
      >
        <FilterTable
          handleSubmitForm={handleSubmitForm}
          isFirstGet={isFirstGet}
          areDatesValid={areDatesValid}
        />
        <ErrorBoundary>
          <TableContracts
            tableData={tableData}
            page={page}
            rowsPerPage={rowsPerPage}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
            handleChangePage={handleChangePage}
            areDatesValid={areDatesValid}
          />
        </ErrorBoundary>
      </Card>
    </FormProvider>
  )
}

export default Search